var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:[_vm.mode === 'bottom' ? 'video-watermark_bottom': 'video-watermark_center'],style:({bottom: _vm.bottom + 'px', right: _vm.right() + 'px'})},[_c('img',{style:({width: _vm.scaledRatio}),attrs:{"src":_vm.adaptPic('static/watermark_light_vertical.png'),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726b0145","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/VideoVerticalWatermark.vue
// module id = null
// module chunks = 